import { Dispatch, createContext, useState } from 'react'

interface ModalStateReturn<T> {
  modal: T & { showing: boolean }
  showModal: Dispatch<T>
  showing: boolean
  hide(): void
}

export const createModalContext = <T,>(defaultValue: T) =>
  createContext<ModalStateReturn<T>>({
    modal: { ...defaultValue, showing: false },
    showing: false,
    showModal: () => {},
    hide: () => {}
  })

export const useModalState = <T,>(defaultValue: T): ModalStateReturn<T> => {
  const [modal, setModal] = useState<T & { showing: boolean }>({ ...defaultValue, showing: false })

  return {
    modal,
    showModal: (modalValues) => setModal({ ...modalValues, showing: true }),
    showing: modal.showing,
    hide: () => setModal({ ...modal, showing: false })
  }
}
